module.exports = __webpack_public_path__ + "img/team2.6b90322e.png";